export default "__VITE_ASSET__B2kA9H3___"